import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { isValidUKPhone } from "@/lib/validation";

export default function Step1PersonalDetails({ data, update }) {
  const phoneTouched = data.phone.length > 0;
  const phoneInvalid = phoneTouched && !isValidUKPhone(data.phone);

  return (
    <div className="space-y-6" data-testid="step-1-personal">
      <div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Your details</h2>
        <p className="mt-2 text-slate-600">We'll use these to confirm your booking by email.</p>
      </div>

      <div className="grid gap-5">
        <div>
          <Label htmlFor="fullName" className="text-slate-700 font-medium">Full name</Label>
          <Input
            id="fullName"
            data-testid="input-full-name"
            value={data.full_name}
            onChange={(e) => update({ full_name: e.target.value })}
            placeholder="Jane Doe"
            className="mt-1.5 h-12 bg-white border-slate-200 focus-visible:ring-[#FF7F00]"
          />
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <Label htmlFor="phone" className="text-slate-700 font-medium">Phone number</Label>
            <Input
              id="phone"
              data-testid="input-phone"
              value={data.phone}
              onChange={(e) => update({ phone: e.target.value })}
              placeholder="07123 456 789"
              aria-invalid={phoneInvalid}
              className={`mt-1.5 h-12 bg-white focus-visible:ring-[#FF7F00] ${
                phoneInvalid ? "border-red-400 focus-visible:ring-red-400" : "border-slate-200"
              }`}
            />
            {phoneInvalid ? (
              <p data-testid="error-phone" className="mt-1.5 text-xs text-red-600">
                Enter a valid UK phone number (e.g. 07123 456789 or +44 7123 456789).
              </p>
            ) : (
              <p className="mt-1.5 text-xs text-slate-400">UK mobile or landline.</p>
            )}
          </div>
          <div>
            <Label htmlFor="email" className="text-slate-700 font-medium">Email address</Label>
            <Input
              id="email"
              type="email"
              data-testid="input-email"
              value={data.email}
              onChange={(e) => update({ email: e.target.value })}
              placeholder="you@example.com"
              className="mt-1.5 h-12 bg-white border-slate-200 focus-visible:ring-[#FF7F00]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
